import moment from 'moment';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import auth from '../../auth/Auth';
import Card from '../../components/Card/Card';
import MainContainer from '../../components/MainContainer/MainContainer';
import Message from '../../components/Message/Message';
import styles from './CaixaMensagem.module.css';
import iconeCaixaMensagens from '../../assets/img/caixa-mensagens.png';
import iconeCaixaMensagensVazia from '../../assets/img/caixa-mensagens-vazia.png';

import {
  alterarMensagem,
  ativarMensagem,
  getCaixaMensagens,
  getCaixaMensagensIdPositiva,
  getCaixaMensagensRL,
  getQuantidadeMensagensNaoLidas,
  getQuantidadeMensagensNaoLidasIdPositiva,
  getQuantidadeMensagensNaoLidasRL,
  limpar,
  limparLastApiCallTime,
  selectCaixaMensagens,
  selectQuantidadeMensagensNaoLidas,
  selectState,
} from './CaixaMensagemSlice';
import authIdPositiva from '../../auth/AuthIdPositiva';
import { selectPerfilCompleto, selectSelecionouSolicitacaoCadastramento, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import { selectLoadingCount } from '../../globalSlice';
import { authLogout } from '../../auth/authSlice';
import { TipoPerfil } from '../../model/TipoPerfil';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';

const CaixaMensagem: React.FC = (props) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector(selectState);
  const caixaMensagens = useAppSelector(selectCaixaMensagens);
  const quantidadeMensagensNaoLidas = useAppSelector(selectQuantidadeMensagensNaoLidas);
  const loadingCount = useAppSelector(selectLoadingCount);

  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const history = useHistory();

  const selecionouSolicitacaoCadastramento = useAppSelector(selectSelecionouSolicitacaoCadastramento);

  useEffect(() => {
    if (auth.isAuthenticated() && perfil) {

      let perfilRepresentanteLegal = perfil?.tipoPerfil?.codigo === TipoPerfil.REPRESENTANTE_LEGAL;
      if (perfilRepresentanteLegal) {
        dispatch(getCaixaMensagensRL(perfil.identificador));
        dispatch(getQuantidadeMensagensNaoLidasRL(perfil.identificador));
      } else{
        dispatch(getCaixaMensagens(perfil.identificador));
        dispatch(getQuantidadeMensagensNaoLidas(perfil.identificador));
      }
    } else if (authIdPositiva.isAuthenticated()) {
      dispatch(getCaixaMensagensIdPositiva(authIdPositiva.getUserId()));
      //adicionado aqui para atualizar a quantidade de mensagens não lidas
      dispatch(getQuantidadeMensagensNaoLidasIdPositiva(authIdPositiva.getUserId()));
    }
    return () => {
      dispatch(limpar());
      dispatch(limparLastApiCallTime());
      dispatch(alterarMensagem(''));
      dispatch(ativarMensagem(false));
    };
  }, [dispatch, perfil]);

  const limparMensagens = () => {
    dispatch(alterarMensagem(''));
    dispatch(ativarMensagem(false));
  };

  const obterMensagemComTipo = (mensagem) => {
    setTimeout(() => {
      dispatch(ativarMensagem(false));
    }, 1000000);

    return (
      <div onClick={() => limparMensagens()}>
        <Message id="mensagem" type="warning" title={mensagem} className={styles.message} />
      </div>
    );
  };

  const exibirMensagem = (data) => {
    return (
      <div className={styles.headerMensagem} onClick={() => detalharMensagem(data)}>
        <i
          className={
            !data.mensagemLida
              ? `fas fas fa-envelope ${styles.iconEnvelope}`
              : `fas fas fa-envelope-open-text ${styles.iconEnvelope}`
          }
        />
        <div>
          <div>
            {data?.dataEnvioMensagem && (
              <span>{moment(data?.dataEnvioMensagem).format('DD/MM/YYYY')}</span>
            )}
            {!data?.dataEnvioMensagem && data?.dataMensagem && (
              <span>{moment(data?.dataMensagem).format('DD/MM/YYYY')}</span>
            )}
          </div>
          <div className={!data.mensagemLida ? styles.mensagemNaoLida : ''}>
            {data.tituloMensagem}
          </div>
        </div>
      </div>
    );
  };

  const detalharMensagem = (data) => {
    history.push({
      pathname: '/caixa-mensagem-detalhe',
      state: {
        mensagemSelecionada: data,
      },
    });
  };

  const exibirCaixaMensagens = () => {
    return (
      <Card>
        {!selecionouSolicitacaoCadastramento && caixaMensagens.map((data, id) => {
          return (
            <div key={id}>
              {exibirMensagem(data)}
              <hr />
            </div>
          );
        })}
        <div className={styles.resumoCaixaMensagens}>

          {!selecionouSolicitacaoCadastramento && caixaMensagens && caixaMensagens.length > 0 ? (
            <>
              <div>
                <img src={iconeCaixaMensagens} alt="Caixa de mensagens" />
              </div>
              {caixaMensagens.length} {caixaMensagens.length === 1 ? 'mensagem' : 'mensagens'}
              {quantidadeMensagensNaoLidas > 0 && (
                <span>
                  ,{' '}
                  <strong>
                    {quantidadeMensagensNaoLidas} não lida
                    {quantidadeMensagensNaoLidas !== 1 ? 's' : ''}
                  </strong>
                </span>
              )}
            </>
          ) : (
            <div>
              <img
                src={iconeCaixaMensagensVazia}
                alt="Caixa de mensagens"
              />
            </div>
          )}
        </div>
        {state.ativarMensagem && obterMensagemComTipo(state.mensagem)}
      </Card>
    );
  };

  const voltarParaPainel = async () => {
    history.goBack();
  };

  const irCaixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const logout = () => {
    dispatch(limpar());
    dispatch(authLogout({ history }));
  };

  return (
    <MainContainer
      navSeparator
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      navGoBack={voltarParaPainel}
      userNav={true}
      titleBarraAuxiliar={"Mensagem"}
      barraAuxiliar={true}
      stoppedTitle={true}
      navFixed
      navCaixaMensagens={irCaixaMensagens}
      navHideArrow={false}
      navLogout={logout}>
      <div className={styles.container}>
        {loadingCount === 0 && (
          <>
            {exibirCaixaMensagens()}
          </>
        )}
      </div>
    </MainContainer>
  );
};

export default CaixaMensagem;
